import CryptoJS from 'crypto-js';

// const key = '41f9cbe46789db07cd34920df3a7c3c6'; // sanjeevani key
const key = '706ae7ac3fe4001a0ccffb6b5bacdfff'; // DecsoPlus key


const AesEncrypt = (textData: any) => {
    const iv = CryptoJS.lib.WordArray.random(16); // Generating a random IV
    const cipherText = CryptoJS.AES.encrypt(JSON.stringify(textData), CryptoJS.enc.Hex.parse(key), {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    const Res = {
        data: cipherText.toString(),
        iv: iv.toString(CryptoJS.enc.Base64)
    };
    return Res;
}

const AesDecrypt = (encryptedData: any) => {
    try {
        const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData.data);
        const iv = CryptoJS.enc.Base64.parse(encryptedData.iv);

        const cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: encryptedDataBytes
        });

        const decrypted = CryptoJS.AES.decrypt(
            cipherParams,
            CryptoJS.enc.Hex.parse(key),
            { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
        );

        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedString);
    } catch (error: any) {
        console.error('Error during decryption:', error.message);
        throw error;
    }
};

export { AesEncrypt, AesDecrypt };
